import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { zefGo } from '@zerops/zef/ngrx-router';
import { storeUserDataSuccess } from '@zerops/zerops/core/user-base';
import { filter, map } from 'rxjs/operators';
import { readCarriedDeviceLoginRequest } from './device-login.carry';

@Injectable()
export class DeviceLoginBaseEffect {

  #actions$ = inject(Actions);

  /**
   * Returns to the consent screen once the sign-in, including 2FA, is complete.
   * It lives in core because the OAuth sign-in reloads the app before the lazy page module is loaded.
   * The page forgets the request once it loads, so a reload that interrupts this navigation resumes again.
   */
  onFullyAuthedResume$ = createEffect(() => this.#actions$.pipe(
    ofType(storeUserDataSuccess),
    map(() => readCarriedDeviceLoginRequest()),
    filter((requestId): requestId is string => !!requestId),
    map((request) => zefGo([ '/authorize-login' ], { request }))
  ));

}
